import { Fragment, ReactNode, useState } from "react";
import { cn } from "~/lib/utils";

interface DividedListProps<T extends { id: string | number }> {
  items: T[];
  renderItem: (item: T) => ReactNode;
  className?: string;
  "data-testid"?: string;
}

export const DividedList = <T extends { id: string | number }>({
  items,
  renderItem,
  className,
  "data-testid": testId,
}: DividedListProps<T>) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <div role="list" className={cn("flex flex-col", className)} data-testid={testId}>
      {items.map((item, index) => (
        <Fragment key={item.id}>
          {index > 0 && (
            <hr
              className={cn(
                "border-border/50 m-0 transition-opacity duration-150",
                (hoveredIndex === index || hoveredIndex === index - 1) && "opacity-0"
              )}
            />
          )}
          <div
            role="listitem"
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
          >
            {renderItem(item)}
          </div>
        </Fragment>
      ))}
    </div>
  );
};
